import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroCardStyles as styles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing } from '../../../styles';

export const customCardStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${styles(context, definition)}
  ${boxSizing}
  :host {
    display: flex;
    flex-direction: column;
  }

  :host ::slotted(.card-header) {
    background: var(--card-header-bg);
    font-size: 0.813rem;
    padding: 0.6rem 1rem;
  }

  :host ::slotted(.card-body) {
    background: var(--neutral-layer-3);
    border: 1px solid var(--border-1);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }
`;
